import { render, staticRenderFns } from "./TerminalImpressaoConfig.vue?vue&type=template&id=308ef706&scoped=true&"
import script from "./TerminalImpressaoConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./TerminalImpressaoConfig.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ef706",
  null
  
)

export default component.exports